module.exports = __webpack_public_path__ + "img/2icon.8bc71612.png";